import type { Screen } from '../store/uiStore';
import { useUi } from '../store/uiStore';

const ITEMS: Array<{ id: Screen; label: string; hint: string }> = [
  { id: 'overview', label: 'Overview', hint: 'services, numbers, alarms, timeline' },
  { id: 'people', label: 'People', hint: 'accounts, cut-offs, Clerk controls' },
  { id: 'studios', label: 'Studios & projects', hint: 'rosters, invites, machines, config' },
  { id: 'machines', label: 'Machines', hint: 'enrolled machines by studio' },
  { id: 'packages', label: 'Packages', hint: 'the package index' },
  { id: 'deploys', label: 'Deploys & config', hint: 'what is running where, and drift' },
  { id: 'logs', label: 'Logs & traces', hint: 'saved Logs Insights queries' },
  { id: 'posture', label: 'Security posture', hint: 'live checks with reasons' },
];

export function Rail() {
  const { screen, go } = useUi();
  return (
    <nav style={{ width: 200, flexShrink: 0, padding: '18px 10px', borderRight: '1px solid var(--bd-soft)', display: 'flex', flexDirection: 'column', gap: 2 }} aria-label="Screens">
      {ITEMS.map((it) => {
        const on = it.id === screen;
        return (
          <button key={it.id} onClick={() => go(it.id)} aria-current={on || undefined} className="row-hover" style={{
            textAlign: 'left', padding: '9px 12px', borderRadius: 'var(--r-ctl)', background: on ? 'var(--bg-elev)' : 'transparent',
          }}>
            <div style={{ fontFamily: 'var(--ff-sans)', fontSize: 13.5, fontWeight: 500, color: on ? 'var(--fg)' : 'var(--fg-2)' }}>{it.label}</div>
            <div style={{ fontFamily: 'var(--ff-code)', fontSize: 11, color: 'var(--fg-4)', marginTop: 2 }}>{it.hint}</div>
          </button>
        );
      })}
    </nav>
  );
}
